<template>
    <div class="tag-container">
        <p class="tag-title">{{tagTitle}}:</p>
        <div class="tag-item">
           <span 
           v-for="(tag, index) in tagData" 
           :key="tag.id" 
           @click="tagEvn(tag, index)"
           :class="{'activeTag': tagArr.includes(tag)}"
           >{{tag.name}}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tagData: {
            type: Array
        },
        tagTitle: {
            type: String,
            default: '选择标签'
        }
    },
    data() {
        return {
            tagID: '',
            tagArr: []
        }
    },

    methods: {
        tagEvn(tag, index) {
            if(this.tagArr.includes(tag)){
                let idx = this.tagArr.indexOf(tag)
                this.tagArr.splice(idx, 1)
            }else{
                this.tagArr = [...this.tagArr, tag]
            }
            this.$emit('tagEvn', this.tagArr)
        }
    }
}
</script>

<style lang="scss" scoped>
    .tag-container{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .tag-item{
            flex:1;
            display: flex;
            flex-wrap: wrap;

            span{
                display: block;
                border:1px solid $globalBorderColor;
                width:90px;
                height:28px;
                line-height: 28px;
                text-align: center;
                cursor: pointer;
                padding:0 5px;
                border-radius: 4px;
                margin:5px;
                transition: all .3s;
            }
            .activeTag{
                background: $globalBGColor;
                border:1px solid $globalBGColor;
                color:#fff;
            }
        }
    }
</style>

